export default __webpack_public_path__ + "static/media/게임설명.dedc7bd5.jpg";